import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode, our Charlotte team is here when you need us, providing reliable support and thoughtful solutions.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise",
        description: "At Mobikode, we create practical digital solutions for diverse industries, helping Charlotte businesses grow, connect, and thrive.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every Charlotte business is different, so we create tailored digital solutions that simplify work, meet goals, and support growth.",
        image: "/assets/mumbai/img2.png"
    },
];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help Charlotte’s financial businesses simplify operations, serve customers better, and grow confidently with secure, reliable technology solutions built around their needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Charlotte’s eCommerce businesses grow with simple, reliable digital solutions that improve customer experiences, streamline operations, and build lasting success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "At Mobikode, we help Charlotte’s insurance companies simplify operations, improve customer experiences, streamline claims and policies, and grow confidently with secure, reliable digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help Charlotte’s manufacturing businesses adopt smarter technology, simplify daily operations, improve productivity, and build efficient processes that support sustainable, long-term growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we help Charlotte’s retail and consumer brands grow with thoughtful digital solutions that enhance customer experiences, simplify operations, and support lasting business growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Charlotte’s Healthcare and Life Sciences organizations use technology to simplify care, support teams, improve patient experiences, and achieve better health outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "At Mobikode, we help Charlotte’s media and communications businesses blend technology and creativity to connect with audiences, simplify operations, and build stronger, lasting engagement.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help Charlotte’s logistics and transportation businesses simplify operations, improve delivery experiences, and grow confidently with reliable digital solutions built around real-world needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help Charlotte’s technology companies turn ideas into meaningful digital solutions, combining creativity and expertise to build reliable products that support lasting business growth.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we help Charlotte’s nonprofit organizations use technology to reach more people, simplify everyday work, and create meaningful, lasting impact in their communities.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help Charlotte’s professional service businesses simplify processes, embrace smarter technology, and deliver better client experiences with reliable, tailored digital solutions built for their needs.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Charlotte’s real estate businesses grow with smart digital solutions that simplify operations, improve experiences, and bring builders, agents, and buyers closer together.",
        image: "/assets/mumbai/item12.png"
    },
];

function Charlotte() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Charlotte | ITSM & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers ServiceNow consulting in Charlotte to help businesses streamline IT operations, automate workflows, integrate enterprise systems, and improve service management with scalable digital solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Charlotte, ServiceNow Consultant Charlotte, ServiceNow Implementation Charlotte, ServiceNow Integration Charlotte, ServiceNow ITSM Charlotte, ServiceNow Managed Services Charlotte, ServiceNow Automation Charlotte, ServiceNow Development Charlotte, ServiceNow Solutions Charlotte, ServiceNow Consulting Company Charlotte"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-houston"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Charlotte | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform service management with Mobikode's ServiceNow consulting solutions in Charlotte. Improve workflows, automate processes, connect business systems, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-charlotte"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Charlotte | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Get tailored ServiceNow consulting solutions in Charlotte for IT service management, workflow automation, system integration, and digital transformation."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />
            </Helmet>

            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Charlotte" description="Partner with Mobikode’s ServiceNow experts in Charlotte to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/charlotte.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Charlotte
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Charlotte to simplify work, automate workflows, empower teams, and grow confidently.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Melbourne.png"}
                text={"At Mobikode, we help Charlotte businesses make ServiceNow work better for their people and processes. From implementation and customization to integrations and ongoing support, our experts simplify workflows and automate routine tasks. We focus on practical solutions that improve efficiency, enhance user experiences, and scale with your business, helping you move forward confidently on your digital transformation journey."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help Charlotte businesses get more from ServiceNow with tailored consulting, smart automation, and practical solutions that simplify work, improve efficiency, and enhance experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Charlotte
